/**
 * Gedeelde helpers voor de DB-laag (stripUndefined, business hours normalisatie).
 */

import type { BusinessHours, Weekday } from '../../types/salon'
import { WEEKDAYS } from '../../types/salon'
import { normalizeBusinessDayTimes } from '../../lib/salonBusinessHoursRange'

export { WEEKDAYS }

/** Verwijdert undefined waarden uit een object. */
export function stripUndefined<T extends object>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined)
  ) as Partial<T>
}

function defaultBusinessHours(): BusinessHours {
  return Object.fromEntries(WEEKDAYS.map((day) => [day, { open: false }])) as BusinessHours
}

export function normalizeBusinessHours(raw: unknown): BusinessHours {
  const out = defaultBusinessHours()
  if (!raw || typeof raw !== 'object') return out
  const obj = raw as Record<string, unknown>
  for (const day of WEEKDAYS) {
    const d = obj[day]
    if (d && typeof d === 'object' && d !== null && 'open' in d) {
      const o = d as { open?: boolean; start?: string; end?: string }
      const start = typeof o.start === 'string' ? o.start : undefined
      const end = typeof o.end === 'string' ? o.end : undefined
      const open = Boolean(o.open)
      if (open && start && end) {
        const { start: ns, end: ne } = normalizeBusinessDayTimes(start, end)
        out[day as Weekday] = { open: true, start: ns, end: ne }
        continue
      }
      out[day as Weekday] = {
        open,
        start,
        end,
      }
    }
  }
  return out
}
